export const TABLE = {
  DEFAULT_LIMIT: 50,
}
